"use client"

import { ColumnDef } from "@tanstack/react-table"
import { ArrowUpDown } from "lucide-react"
import { Button } from "@/components/ui/button"
import { Checkbox } from "@/components/ui/checkbox"
import { format } from 'date-fns';
import AssetsRowActions from "./AssetsRowActions"


export type Assets = {
  id: string
  customer_name: string
  product_name: string
  technician_name: number
  cid: number
  registration: string
  client_name: string
  loan_id: string
  status: number
  slug: number
  created_at: Date
  updated_at: Date
  customer_id: number,
  customer_status: number,
  customer_slug: string,
  technician_id: number,
  technician_store_id: number,
  technician_email: string,
  technician_phone: string,
  technician_status: number,
  product_id: number,
  product_status: number,
  beacon_id: number,
  beacon_cid: string,
  beacon_tag_no: string,
  online_status: number,
  expired_at: Date
}

interface rowActionProps {
  onEdit: (data: any) => void
  onDelete: (data: any) => void
  onActivateVehicle: (data: any) => void
  roles: string[]
}

export const AssetColumns = ({ onEdit, onDelete, onActivateVehicle, roles }: rowActionProps): ColumnDef<Assets>[] => {
  const columns: ColumnDef<Assets>[] = [

    {
      accessorKey: "id",
      header: "id",
    },
    {
      accessorKey: "customer_name",
      header: "Customer Name",
    },
    {
      accessorKey: "product_name",
      header: "Product Name",
    },
    {
      accessorKey: "technician_name",
      header: "Technician Name",
    },
    {
      accessorKey: "beacon_cid",
      header: "Beacon Cid",
    },

    {
      accessorKey: "registration",
      header: ({ column }) => {
        return (
          <Button
            variant="ghost"
            onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
          >
            registration
            <ArrowUpDown className="ml-2 h-4 w-4" />
          </Button>
        )
      },
    },
    {
      accessorKey: "client_name",
      header: "Client Name",
    },
    {
      accessorKey: "loan_id",
      header: "Loan id",
    },
    {
      accessorKey: "online_status",
      header: "Online Status",
      cell: ({ row }) => {
        const value: any = row.original
        const statusText = value.status === 1 ? "ONLINE" : "OFFLINE"
        const bgColor = value.status === 1 ? "bg-green-500" : "bg-red-500"
        return (
          <span className={`px-2  rounded-full ${bgColor} text-white`}>
            {statusText}
          </span>
        );
      },
    },

    {
      accessorKey: "status",
      header: "status",
      cell: ({ row }) => {
        const value: any = row.original
        const statusText = value.status === 1 ? "installed" : "not installed"
        const bgColor = value.status === 1 ? "bg-green-500" : "bg-red-500"
        return (
          <span className={`px-2  rounded-full ${bgColor} text-white`}>
            {statusText}
          </span>
        );
      },
    },
    {
      accessorKey: "expired_at",
      header: ({ column }) => {
        return (
          <Button
            variant="ghost"
            onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
          >
            Expired At
            <ArrowUpDown className="ml-2 h-4 w-4" />
          </Button>
        );
      },
      cell: ({ row }) => {
        let expire_at = row.original.expired_at;
        let formattedDate = expire_at
          ? format(new Date(expire_at), 'yyyy-MM-dd HH:mm:ss')
          : undefined;

        return formattedDate ? (
          <span className="  px-2 bg-red-500 text-white  rounded-full"> {formattedDate}</span>
        ) : (
          <span className="  px-2 bg-green-500 text-white  rounded-full">Active</span>
        );
      },
    },
    {
      accessorKey: "created_at",
      header: ({ column }) => {
        return (
          <Button
            variant="ghost"
            onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
          >
            Created At
            <ArrowUpDown className="ml-2 h-4 w-4" />
          </Button>
        )
      },
      cell: ({ row }) => {
        const formattedDate = format(new Date(row.original.created_at), 'yyyy-MM-dd HH:mm:ss');
        return <span>{formattedDate}</span>;
      },
    },
    {
      accessorKey: "updated_at",
      header: ({ column }) => {
        return (
          <Button
            variant="ghost"
            onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
          >
            Updated At
            <ArrowUpDown className="ml-2 h-4 w-4" />
          </Button>
        )
      },
      cell: ({ row }) => {
        const formattedDate = format(new Date(row.original.updated_at), 'yyyy-MM-dd HH:mm:ss');
        return <span>{formattedDate}</span>
      },
    },

  ]

  if (roles.includes('asset-edit') || roles.includes('asset-delete')) {
    columns.push({
      id: "actions",
      header: 'Actions',
      cell: ({ row }) => <AssetsRowActions row={row} onEdit={onEdit} onDelete={onDelete} onActivateVehicle={onActivateVehicle} roles={roles} />,
    })
  }
  return columns
}
